// TBC!!
import React from 'react';

const PageLoader: React.FC = () => <div />;

export default PageLoader;
